import React from 'react';
import { Link, useLocation } from 'react-router-dom';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    if (isHome) {
      e.preventDefault();
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <div className="min-h-screen bg-[#FBF9F7]" data-id="element-142">
      <header className="fixed top-0 left-0 right-0 z-50 px-6 py-4 bg-[#A88B9D]" data-id="element-143">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-144">
          <Link to="/" className="block" data-id="element-145">
            <img src="https://cdn.magicpatterns.com/uploads/dFmWf3Wq1doYcn874k4RUX/UBD.jpg" alt="Underlined by Dania" className="h-12 md:h-14 w-auto mix-blend-lighten" data-id="element-146" />
          </Link>
          <nav className="hidden md:flex gap-8" data-id="element-147">
            <Link to={isHome ? '#' : '/'} className="text-sm font-medium text-white/90 hover:text-white transition-colors" data-id="element-148">
              Home
            </Link>
            <a href={isHome ? '#contact' : '/#contact'} onClick={e => scrollToSection(e, 'contact')} className="text-sm font-medium text-white/90 hover:text-white transition-colors" data-id="element-149">
              Contact
            </a>
            <Link to="/blog" className="text-sm font-medium text-white/90 hover:text-white transition-colors" data-id="element-150">
              Blog
            </Link>
          </nav>
        </div>
      </header>

      <main className="pt-20" data-id="element-151">{children}</main>

      <footer className="px-6 py-8 bg-[#4A3B47] text-[#FBF9F7]/70 text-sm" data-id="element-152">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-153">
          <div className="flex items-center gap-3" data-id="element-154">
            <img src="https://cdn.magicpatterns.com/uploads/dFmWf3Wq1doYcn874k4RUX/UBD.jpg" alt="Underlined by Dania" className="h-8 w-auto" data-id="element-155" />
            <span data-id="element-156">&copy; {new Date().getFullYear()} All rights reserved.</span>
          </div>
          <p className="text-[#A88B9D]" data-id="element-157">Designed with intention.</p>
        </div>
      </footer>
    </div>;
}